import { Component, useEffect } from 'react'
import { Formik } from 'formik'
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements'
import { PlatformForm } from './platform/form'
import { IframeForm } from './iframe/form'
import { ClientForm } from './client/form'
import { SkiForm } from './ski/form'
import {
  CodonationWatcher,
  buildInitialValues,
  buildValidationSchema,
  submitHandler,
  trackDonateFormVisit,
} from './shared'
import { StoreRecaptchaToken, gaEvent, report } from 'shared'

export const DonateForm = (props) =>
  <ErrorBoundary {...props}>
    <StripeProvider apiKey={props.config.stripePublicKey}>
      <Elements locale={I18n.locale}>
        <InjectedFormSetup {...props} />
      </Elements>
    </StripeProvider>
  </ErrorBoundary>

// this component is only exported for testing
export const FormSetup = (props) => {
  const { config, display, stripe, elements } = props
  useEffect(() => trackDonateFormVisit({ config, display }), [config, display])

  let FormComponent
  if (display.layout === 'donate/platform') FormComponent = PlatformForm
  else if (display.layout === 'donate/iframe') FormComponent = IframeForm
  else if (display.layout === 'donate/ski') FormComponent = SkiForm
  else FormComponent = ClientForm

  const initialValues = {
    ...buildInitialValues({ config }),
    _stripe: stripe,
    _stripe_get_element: elements && elements.getElement,
  }

  return <Formik
    validationSchema={buildValidationSchema()}
    initialValues={initialValues} onSubmit={submitHandler}>
    {formikProps => <>
      <StoreRecaptchaToken
        sitekey={config.recaptchaSiteKey}
        action='donate'
        verifyCallback={token => formikProps.setFieldValue('recaptcha_token', token)}
        submitCount={formikProps.submitCount}
      />
      <GAErrorTracker errors={formikProps.errors} touched={formikProps.touched} />
      <CodonationWatcher />
      <FormComponent {...formikProps} {...props} />
    </>}
  </Formik>
}

const InjectedFormSetup = injectStripe(FormSetup)

// Attempt to re-render the form without stripe injection in case of error,
// log errors to honeybadger. Ignore loading errors since we cannot do
// anything more.
class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, _info) {
    report(error)
  }

  render() {
    if (this.state.hasError) {
      return <FormSetup {...this.props} />
    }

    return this.props.children
  }
}

const GAErrorTracker = ({ errors, touched }) => {
  Object.keys(errors).forEach(field => {
    if (touched[field]) {
      gaEvent('error', `field: ${field}`, `error: ${errors[field]}`, null, true)
    }
  })
  return null
}
